/**
 * Centralized logging service with environment-aware output
 * - Development: Shows all logs in console
 * - Production: Completely silent for security
 */
export class Logger {
  private static isDev = import.meta.env.VITE_ENVIRONMENT !== 'production' && (import.meta.env.DEV || import.meta.env.VITE_ENVIRONMENT === 'development');

  /**
   * General logging - only shown in development
   */
  static log(message?: any, ...optionalParams: any[]): void {
    if (this.isDev) {
      console.log(message, ...optionalParams);
    }
  }

  /**
   * Error logging - only shown in development, hidden in production
   */
  static error(message?: any, ...optionalParams: any[]): void {
    if (this.isDev) {
      console.error(message, ...optionalParams);
    }
    // Completely silent in production
  }

  /**
   * Warning logging - only shown in development
   */
  static warn(message?: any, ...optionalParams: any[]): void {
    if (this.isDev) {
      console.warn(message, ...optionalParams);
    }
  }

  /**
   * Info logging - only shown in development
   */
  static info(message?: any, ...optionalParams: any[]): void {
    if (this.isDev) {
      console.info(message, ...optionalParams);
    }
  }

  /**
   * Critical error logging - only shown in development, completely silent in production
   */
  static critical(message?: any, ...optionalParams: any[]): void {
    if (this.isDev) {
      console.error('🚨 CRITICAL:', message, ...optionalParams);
    }
    // Completely silent in production for security
  }
}